import { css } from 'lit';

// language=CSS
export const bubbleButton =
css`
    .bubble-button-lg {
        width: 3rem;
        height: 3rem;
        border-radius: 1.5rem;
        border: 0.125rem solid #FFFFFF;
        box-sizing: border-box;
        background-size: 1.125rem auto;
        background-position: center center;
        background-repeat: no-repeat;
        background-color: rgb(var(--sp-color-a));
        box-shadow: var(--sp-default-box-shadow);
    }
    
    .bubble-button {
        width: 2.75rem;
        height: 2.75rem;
        border-radius: 1.375rem;
        border: 0.125rem solid #FFFFFF;
        box-sizing: border-box;
        background-size: 1.125rem auto;
        background-position: center center;
        background-repeat: no-repeat;
        background-color: rgb(var(--sp-color-a));
        box-shadow: var(--sp-default-box-shadow);
    }

    .bubble-button-sm {
        width: 2rem;
        height: 2rem;
        border-radius: 1rem;
        border: 2px solid #FFFFFF;
        box-sizing: border-box;
        background-size: 1rem auto;
        background-position: center center;
        background-repeat: no-repeat;
        background-color: rgb(var(--sp-color-a));
        box-shadow: var(--sp-default-box-shadow);
    }
`;
